const CveTipDivOUtilOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
    label: 'CUFINRE',
    value: '05'
  },
  {
    label: 'Liquidación de la persona moral',
    value: '04'
  },
  {
    label: 'Proviene de CUFIN',
    value: '01'
  },
  {
    label: 'Proviene de CUFIN al 31 de diciembre 2013.',
    value: '06'
  },
  {
    label: 'No proviene de CUFIN',
    value: '02'
  },
  {
    label: 'Reembolso o reducción de capital',
    value: '03'
  },
];

export default CveTipDivOUtilOptions;

